export default __webpack_public_path__ + "media/images/gradient1-2d6a3ea898243c8c9a07d55c4f762fdd.png";